import { Routes, Route } from "react-router";
import { useSelector } from "react-redux";
import { HasPermission } from "Core/security";
import { Navigate } from "react-router-dom";

//Views
import PMUsersMain from "Modules/pmUsers/views/main";
import JiraSummary from "Modules/pmUsers/views/jiraSummary"

const RouterPMUsers = (props) => {
    const user = useSelector(state => state.securityRedux.user);
    return (
        <>
            <Routes>
                {HasPermission(user, "usr") && <Route path="list" element={<PMUsersMain />} />}
                {HasPermission(user, "js") && <Route path="jirasummary" element={<JiraSummary />} />}
                <Route path="*" element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}
export default RouterPMUsers;